import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  userConversationList,
  userSingleConversationList,
  resetUnreadCount,
} from "../actions/chats";
import ContentLoader from "react-content-loader";
import { backendImageUrl } from "../Router/constant";
import { getSocket } from "./socket/socket";

export default function Chats() {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const messagesEndRef = useRef(null);
  const adminId = localStorage.getItem("adminId");
  const {
    chatUserList,
    chatUserListLoader,
    chatSingleUserList,
    chatSingleUserListLoader,
  } = useSelector((state) => state.chats);
  const { profileDetails } = useSelector((state) => state.auth);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const limit = 10;
  const totalPages = chatUserList?.pagination?.totalPages || 1;
  const [chatUserData, setChatUserData] = useState();
  const [converSationId, setConverSationId] = useState();
  const [messageText, setMessageText] = useState("");
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  useEffect(() => {
    if (chatUserList?.data) {
      setIsFirstLoad(false);
    }
  }, [chatUserList]);
  useEffect(() => {
    if (!adminId) return;

    const fetchConversations = () => {
      dispatch(userConversationList(adminId, search, page, limit));
    };

    fetchConversations();
    const interval = setInterval(fetchConversations, 2000);

    return () => clearInterval(interval);
  }, [adminId, search, page, limit, dispatch]);

  useEffect(() => {
    if (chatUserList?.data?.length > 0 && !converSationId) {
      const firstUser = chatUserList.data[0];
      handleUserDetails(firstUser.conversationId, firstUser.user);
    }
  }, [chatUserList?.data]);


  const handleSearch = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  const handleUserDetails = async (Id, userDetails) => {
    dispatch(userSingleConversationList(Id));
    setConverSationId(Id);
    setChatUserData(userDetails);

    dispatch(resetUnreadCount(Id, adminId));
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // ✅ this enables AM/PM
    });
  };
  const getPagination = (page, totalPages) => {
    const pages = [];

    // Always show first page
    pages.push(1);

    // Left dots
    if (page > 2) {
      pages.push("...");
    }

    // Current & next page
    if (page > 1 && page < totalPages) {
      pages.push(page);
    }

    if (page + 1 < totalPages) {
      pages.push(page + 1);
    }

    // Right dots
    if (page + 2 < totalPages) {
      pages.push("...");
    }

    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }

    return [...new Set(pages)];
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("sv-SE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    if (chatSingleUserList?.data?.length > 0) {
      messagesEndRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [chatSingleUserList?.data]);

  useEffect(() => {
    const socket = getSocket();
    if (socket && converSationId) {
      socket.emit("join_conversation", {
        conversationId: converSationId,
      });
    }
  }, [converSationId]);

  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    socket.on("receive_message", (msg) => {
      dispatch({
        type: "ADD_NEW_MESSAGE",
        payload: msg,
      });
    });

    return () => {
      socket.off("receive_message");
    };
  }, []);

  const submitSendMessage = () => {
    if (!messageText.trim() || !converSationId) return;

    const socket = getSocket();
    if (!socket) return;

    const payload = {
      conversationId: converSationId,
      senderId: adminId,
      receiverId: chatUserData?._id,
      text: messageText,
    };
    socket.emit("send_message", payload);
    setMessageText("");
  };

  return (
    <>
      <div className="content d-flex flex-column flex-column-fluid">
        <div className="post d-flex flex-column-fluid">
          <div className="container-xxl">
            <div className="d-flex flex-column flex-lg-row">
              <div className="flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0">
                <div className="card card-flush">
                  {isFirstLoad && chatUserListLoader ? (
                    <div className="container-fluid contactSkeleton">
                      {[...Array(6)].map((_, i) => (
                        <ContentLoader key={i} width="100%" height={50}>
                          <rect
                            x="0"
                            y="0"
                            rx="5"
                            ry="5"
                            width="100%"
                            height="50"
                          />
                        </ContentLoader>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div className="card-header pt-7">
                        <form className="w-100 position-relative">
                          <i className="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                          <input
                            ref={inputRef}
                            type="text"
                            className="form-control form-control-solid ps-12"
                            placeholder="Search users"
                            value={search}
                            onChange={handleSearch}
                          />
                        </form>
                      </div>
                      <div className="card-body pt-5">
                        <div className="me-n5 pe-2 sideUserSection">
                          {chatUserList?.data?.length > 0 ? (
                            chatUserList?.data
                              ?.filter(item => item?.lastMessage && Object.keys(item.lastMessage).length > 0)
                              ?.map((item, index) => {
                                const user = item.user;

                                return (
                                  <div key={item._id || index}>
                                    <div
                                      className={`d-flex flex-stack py-4 UserList ${converSationId === item.conversationId
                                        ? "activeUserList"
                                        : ""
                                        }`}
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleUserDetails(
                                          item.conversationId,
                                          item.user,
                                        )
                                      }
                                    >
                                      <div className="d-flex align-items-center">
                                        <div className="symbol symbol-45px symbol-circle">
                                          {user?.photo?.fileName ? (
                                            <div className="symbol symbol-45px symbol-circle">
                                              <img
                                                alt="Pic"
                                                src={
                                                  backendImageUrl +
                                                  user?.photo?.fileName
                                                }
                                                style={{ objectFit: "cover" }}
                                              />
                                            </div>
                                          ) : (
                                            <span className="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                                              {user?.name
                                                ?.charAt(0)
                                                .toUpperCase()}
                                            </span>
                                          )}
                                        </div>

                                        <div className="ms-5">
                                          <div className="fs-5 fw-bold text-gray-900 text-hover-primary mb-2 text-truncate-custom">
                                            {user?.name}
                                          </div>
                                          <div className="fw-semibold text-muted">
                                            {item?.lastMessage?.text}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="d-flex flex-column align-items-end">
                                        {/* Unread Count Badge */}
                                        {item?.unReadCount > 0 && (
                                          <span
                                            style={{
                                              background: "#ff3b3b",
                                              color: "#fff",
                                              borderRadius: "50%",
                                              minWidth: "22px",
                                              height: "22px",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              fontSize: "12px",
                                              fontWeight: "600",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            {item.unReadCount}
                                          </span>
                                        )}

                                        {/* Time */}
                                        <span className="text-muted fs-7 mb-1">
                                          {formatDate(item?.lastMessage?.createdAt)}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="separator separator-dashed d-none"></div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="text-center py-10 text-muted fw-semibold">
                              User not found
                            </div>
                          )}
                        </div>
                        {chatUserList?.data?.length > 0 && (
                          <div className="row mt-4">
                            <div className="col-md-5">
                              <strong>
                                Total: {
                                  chatUserList?.data
                                    ?.filter(item => item?.lastMessage && Object.keys(item.lastMessage).length > 0)
                                    ?.length || 0
                                }
                              </strong>
                            </div>

                            <div className="col-md-7 d-flex justify-content-end">
                              <ul className="pagination">
                                {/* Prev */}
                                {page > 1 && (
                                  <li className="page-item">
                                    <button
                                      className="page-link"
                                      onClick={() => setPage(page - 1)}
                                    >
                                      Prev
                                    </button>
                                  </li>
                                )}

                                {getPagination(page, totalPages).map(
                                  (item, index) => (
                                    <li
                                      key={index}
                                      className={`page-item ${item === page ? "activePagination" : ""
                                        } ${item === "..." ? "disabled" : ""}`}
                                    >
                                      <button
                                        className="page-link"
                                        disabled={item === "..."}
                                        onClick={() =>
                                          item !== "..." && setPage(item)
                                        }
                                      >
                                        {item}
                                      </button>
                                    </li>
                                  ),
                                )}

                                {/* Next */}
                                {page < totalPages && (
                                  <li className="page-item">
                                    <button
                                      className="page-link"
                                      onClick={() => setPage(page + 1)}
                                    >
                                      Next
                                    </button>
                                  </li>
                                )}
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="flex-lg-row-fluid ms-lg-7 ms-xl-10">
                <div className="card">
                  <div className="card-header">
                    <div className="card-title">
                      {chatUserData?.photo?.fileName ? (
                        <div className="symbol symbol-45px symbol-circle">
                          <img
                            alt="Pic"
                            src={
                              backendImageUrl + chatUserData?.photo?.fileName
                            }
                            style={{ objectFit: "cover" }}
                          />
                        </div>
                      ) : (
                        <div className="symbol symbol-45px symbol-circle">
                          <span className="symbol-label bg-light-danger text-danger fs-6 fw-bolder">
                            {chatUserData?.name?.charAt(0).toUpperCase()}
                          </span>
                        </div>
                      )}
                      <div
                        className="d-flex justify-content-center flex-column"
                        style={{ marginLeft: "10px" }}
                      >
                        <div className="fs-4 fw-bold text-gray-900 text-hover-primary me-1 mb-2 lh-1">
                          {chatUserData?.name}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body sideUserMessageSection">
                    <div className="scroll-y me-n5 pe-5 h-300px h-lg-auto">
                      {chatSingleUserList?.data?.length > 0 ? (
                        chatSingleUserList?.data?.map((msg, index) => {
                          const isAdmin = msg.senderId === adminId;
                          return isAdmin ? (
                            /* ================= RIGHT SIDE (ADMIN) ================= */
                            <div className="d-flex justify-content-end mb-10" key={index}>
                              <div className="d-flex flex-column align-items-end">
                                <div className="p-5 rounded bg-light-primary text-gray-900 fw-semibold mw-lg-400px text-end">
                                  {msg.text}
                                </div>

                                <span className="text-muted fs-7 mt-1">
                                  {formatTime(msg.createdAt)}
                                </span>
                              </div>
                            </div>
                          ) : (
                            /* ================= LEFT SIDE (USER) ================= */
                            <div className="d-flex justify-content-start mb-10" key={index}>
                              <div className="d-flex flex-column align-items-start">
                                <div className="p-5 rounded bg-light-info text-gray-900 fw-semibold mw-lg-400px text-start">
                                  {msg.text}
                                </div>

                                <span className="text-muted fs-7 mt-1">
                                  {formatTime(msg.createdAt)}
                                </span>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="text-center text-muted py-10">
                          No messages found
                        </div>
                      )}
                      <div ref={messagesEndRef} />
                    </div>
                  </div>
                  {chatUserList?.data?.length > 0 && (
                    <div className="card-footer p-4">
                      <div className="d-flex flex-stack">
                        <textarea
                          className="form-control form-control-flush mb-3"
                          rows="1"
                          placeholder="Type a message"
                          value={messageText}
                          onChange={(e) => setMessageText(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              e.preventDefault();
                              submitSendMessage();
                            }
                          }}
                        />

                        <button
                          className="btn activePagination"
                          type="button"
                          style={{ marginLeft: "10px" }}
                          onClick={submitSendMessage}
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
